"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBasketOfferHandler = addBasketOfferHandler;
var _addBasketOffer = require("@ori-events/add-basket-offer");
var _types = require("../types");
var _utils = require("../utils");
async function addBasketOfferHandler(event) {
  if ((0, _addBasketOffer.isAddBasketOfferPurchaseEvent)(event)) {
    const {
      detail: {
        items,
        offerId: choiceId,
        placement
      }
    } = event;
    return (0, _utils.addBasketOffer)(_types.RequestUrl.PurchaseBasketOffer, {
      choiceId,
      items,
      placement
    });
  }
  const {
    detail: {
      offerId,
      placement
    }
  } = event;
  return (0, _utils.addBasketOffer)(_types.RequestUrl.AddBasketOffer, {
    offerId,
    placement
  });
}